<template>
  <div class="frame">
    <draggable class="list"
      tag="div"
      v-model="groups"
      v-bind="dragOptions">
      <transition-group type="transition">
        <div class="groupContainer"
          v-for="item in groups"
          :key="item.id"
          :class="{
            controlContainer: item.defaultGroup === 'default_controls',
            arrowContainer: item.defaultGroup === 'default_arrows',
          }">
          <!-- POWER / VOL / CH -->
          <div v-if="item.defaultGroup === 'default_controls'" class="ctrlColumn">
            <div class="vol btns">
              <span class="label">VOL</span>
              <button type="button" class="btnCtrl"><i>&#43;</i></button>
              <button type="button" class="btnCtrl"><i>&#8722;</i></button>
              <button type="button" class="mute"><img src="@/assets/img/ico_speaker.png" alt="mute" /></button>
            </div>
            <div class="tvInput btns">
              <button class="btnPower"></button>
              <button class="btnCtrl btnExt">{{locale.tvcontrol_ext}}</button>
            </div>
            <div class="ch btns">
              <span class="label">CH</span>
              <button type="button" class="btnCtrl"><i>&#10094;</i></button>
              <button type="button" class="btnCtrl"><i>&#10095;</i></button>
            </div>
          </div>
          <!-- //POWER / VOL / CH -->
          <!-- ARROWS -->
          <div v-else-if="item.defaultGroup === 'default_arrows'" class="arr btns">
            <div class="group">
              <button type="button" class="btnCtrl up"><i>&#10094;</i></button>
              <button type="button" class="btnCtrl right"><i>&#10095;</i></button>
              <button type="button" class="btnCtrl left"><i>&#10094;</i></button>
              <button type="button" class="btnCtrl down"><i>&#10095;</i></button>
            </div>
            <button type="button" class="btnCtrl btnOk">OK</button>
            <button type="button" class="btnCtrl btnMenu">MENU</button>
            <button type="button" class="btnCtrl btnExit">EXIT</button>
          </div>
          <!-- //ARROWS -->
          <div v-else class="groupBox">
            <button class="btnCtrl"
              v-for="inner in item.group"
              :key="inner.id"
              :class="{
                remoteEmpty: remoteEmpty(inner.id),
                remoteGroup: remoteGroup(inner.id),
                remoteColor: remoteColor(inner.id)
              }"
              :data-button="inner.id">
              <img v-if="remoteIcon.includes(inner.id)" :src="getIcon(inner.id)" :alt="inner.id" />
              <span v-else>{{inner.name}}</span>
            </button>
          </div>
        </div>
      </transition-group>
    </draggable>
<!-- 
    <div class="ctrlColumn">
      <div class="vol btns">
        <span class="label">VOL</span>
        <button type="button" class="btnCtrl"><i>&#43;</i></button>
        <button type="button" class="btnCtrl"><i>&#8722;</i></button>
        <button type="button" class="mute"><img src="@/assets/img/ico_speaker.png" alt="mute" /></button>
      </div>
      <div class="tvInput btns">
        <button class="btnPower"></button>
        <button class="btnCtrl btnExt">{{locale.tvcontrol_ext}}</button>
      </div>
      <div class="ch btns">
        <span class="label">CH</span>
        <button type="button" class="btnCtrl"><i>&#10094;</i></button>
        <button type="button" class="btnCtrl"><i>&#10095;</i></button>
      </div>
    </div>
    <div class="arr btns">
      <div class="group">
        <button type="button" class="btnCtrl up"><i>&#10094;</i></button>
        <button type="button" class="btnCtrl right"><i>&#10095;</i></button>
        <button type="button" class="btnCtrl left"><i>&#10094;</i></button>
        <button type="button" class="btnCtrl down"><i>&#10095;</i></button>
      </div>
      <button type="button" class="btnCtrl btnOk">OK</button>
      <button type="button" class="btnCtrl btnMenu">MENU</button>
      <button type="button" class="btnCtrl btnExit">EXIT</button>
    </div>
    <div v-if="remocon !== '' && activeRemote.length > 0" class="activeRemote">
      <button class="btnCtrl"
        v-for="button in activeRemote"
        :key="button.id"
        :class="{
          remoteEmpty: remoteEmpty(button.id),
          remoteGroup: remoteGroup(button.id),
          remoteColor: remoteColor(button.id)
        }"
        :data-button="button.id">
        <img v-if="remoteIcon.includes(button.id)" :src="getIcon(button.id)" :alt="button.id" />
        <span v-else>{{button.name}}</span>
      </button>
    </div>
     -->
    <!--
    <div class="num">
      <button type="button" class="btnCtrl"
        v-for="num in numbers"
        :key="num">
        {{num}}
      </button>
    </div>
     -->
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: [
    'locale',
    'activeRemote',
    'remoteIcon',
    'colors',
    'remocon'
  ],
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    groups: {
      get () {
        const activeRemote = this.activeRemote
        const groups = function () {
          let current = 0
          let arr = []
          for (let i = 0; i < activeRemote.length; i++) {
            if (activeRemote[i].id.includes('default_controls') ||
                activeRemote[i].id.includes('default_arrows') ||
                (activeRemote[i + 1] && activeRemote[i + 1].id.includes('default_controls')) ||
                (activeRemote[i + 1] && activeRemote[i + 1].id.includes('default_arrows')) ||
                activeRemote[i].id.includes('remote_empty') ||
                activeRemote[i].id.includes('remote_group') ||
                i === activeRemote.length - 1) {
              arr.push(activeRemote.slice(current, i + 1))
              current = i + 1
            }
          }
          return arr
        }
        let result = groups().map((x, i) => {
          return {
            id: `group_${i}`,
            defaultGroup: x.filter(x => {
              return x.id.includes('default_controls') || x.id.includes('default_arrows')
            }).length > 0 ? x[0].id : false,
            group: x
          }
        })
        return result
      },
      set (group) {
        const reGroup = group.map(x => x.group).flat()
        this.$emit('changeGroup', reGroup)
      }
    }
  },
  data () {
    return {
      defaultRemote: [
        { id: 'default_controls' },
        { id: 'default_arrows' }
      ]
    }
  },
  methods: {
    remoteEmpty (id) {
      return id.includes('remote_empty')
    },
    remoteGroup (id) {
      return id.includes('remote_group')
    },
    remoteColor (id) {
      const colors = this.colors
      return colors.includes(id)
    },
    getIcon (id) {
      const img = id.replace(/(\s*)/g, '')
      return require(`@/assets/img/tvcontroller/ico_${img}.png`)
    }
  }
}
</script>

<style lang="scss" scoped>
$color-btn: #32323a;
.groupContainer {
  position: relative;
  cursor: move;
}
.groupContainer:hover {
  z-index: 1;
}
.groupContainer:hover:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid $color-blue;
  background-color: rgba($color-blue, 0.2);
  z-index: 9;
}
.controlContainer + .arrowContainer {
  margin-top: -40px;
}
.arrowContainer {
  padding: 50px 0;
}
.frame {
  flex: 1;
  width: 340px;
  height: 100%;
  overflow: auto;
  padding: 30px 30px 60px;
  font-family: 'Pretendard', 'Noto Sans', 'Kosugi Maru', 'Noto Sans SC', 'Noto Sans KR', 'sans-serif';
  color: $color-white;
  background-color: #1a1c1d;
}
.btnCtrl {
  flex: auto;
  height: 40px;
  margin: 1px;
  padding: 0;
  font-size: 1.2em;
  line-height: 1;
  border-radius: 2px;
  background-color: $color-btn;
  img {
    height: 20px;
  }
  &.color {
    font-size: 0;
    text-indent: -9999px;
  }
  &:active {
    color: #19e4e4;
    box-shadow: inset 0 0 5px 2px rgba(0,0,0,0.3);
  }
}
.ctrlColumn {
  text-align: center;
}
.vol,
.ch,
.tvInput {
  display: inline-block;
  vertical-align: top;
  width: 30%;
  max-width: 23%;
}
.vol,
.ch {
  position: relative;
  .label {
    font-size: 0.8em;
  }
  .btnCtrl {
    flex: none;
    width: 100%;
    height: 60px;
    font-size: 3.2em;
    i {
      position: relative;
    }
  }
  .mute {
    width: 100%;
    margin-top: 10px;
    padding: 8px 0;
    img {
      height: 24px;
      opacity: 0.5;
    }
  }
}
.vol i {
  top: -0.1em;
}
.ch i {
  display: inline-block;
  top: -0.25em;
  left: 0.1em;
  font-size: 0.7em;
  transform: rotate(90deg);
}
.tvInput {
  max-width: 30%;
  margin: 30px 30px 0;
  align-items: center;
  .btnCtrl {
    width: 100%;
    height: auto;
    margin-top: 10px;
    padding: 0.5em 0;
    font-size: 0.8em;
  }
  .btnPower {
    position: relative;
    width: 100%;
    height: 60px;
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      border: 6px solid $color-white;
      transform: translate(-50%, -50%);
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 30px;
      margin-top: -15px;
      border-radius: 10px;
      border: 6px solid #1a1c1d;
      background-color: $color-red;
      transform: translate(-50%, -50%);
    }
    &:active {
      &:before {
        border-color: #19e4e4;
      }
      &:after {
        background-color: $color-white;
      }
    }
  }
}
.arr {
  position: relative;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  font-size: 1.4em;
  .group {
    transform: rotate(45deg);
  }
  .btnCtrl {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0;
    padding: 0;
    border: 1px solid #1a1c1d;
    i {
      display: inline-block;
      position: relative;
    }
  }
  .btnOk {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    border-radius: 2px;
    background-color: #1a1c1d;
    box-shadow: inset 0 0 5px rgba(0,0,0,0.5);
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .btnMenu {
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 80px;
    height: auto;
    margin-bottom: -35px;
    margin-right: -24px;
    padding: 0.5em 0;
    font-size: 0.85em;
  }
  .btnExit {
    position: absolute;
    bottom: 0;
    left: 100%;
    width: 80px;
    height: auto;
    margin-bottom: -35px;
    margin-left: -20px;
    padding: 0.5em 0;
    font-size: 0.85em;
  }
  .up i {
    top: -20px;
    left: -20px;
    transform: rotate(45deg);
  }
  .down i {
    bottom: -20px;
    right: -20px;
    transform: rotate(45deg);
  }
  .left i {
    bottom: -20px;
    left: -20px;
    transform: rotate(-45deg);
  }
  .right i {
    top: -20px;
    right: -20px;
    transform: rotate(-45deg);
  }
}
.num {
  flex-wrap: wrap;
  text-align: center;
  .btnCtrl {
    width: calc(33.33% - 2px);
  }
}
.groupBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
}
.groups {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  flex: auto;
}
.remoteEmpty {
  width: 100%;
  height: 15px;
  margin: 0;
  font-size: 0;
  background: none;
  box-shadow: none;
  opacity: 0;
  z-index: -1;
}
.remoteGroup {
  width: 100%;
  height: 0;
  margin: 0;
  font-size: 0;
  opacity: 0;
  z-index: -1;
}
.remoteColor {
  position: relative;
  font-size: 0;
  text-indent: -9999px;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    margin-top: -8px;
    margin-left: -8px;
    border-radius: 100%;
    box-shadow: 0 0 5px rgba(0,0,0,0.5);
  }
  &[data-button="red"]:before {
    background-color: #dc3746;
  }
  &[data-button="green"]:before {
    background-color: #72b333;
  }
  &[data-button="blue"]:before {
    background-color: #238fce;
  }
  &[data-button="yellow"]:before {
    background-color: #e4cc2c;
  }
}
</style>
